import React, { memo } from 'react';

import { FIAT_MAX_FRACTION } from 'common/constants/fractions.constants';
import { localizeNumber } from 'common/helpers';
import { useCustomer, useI18n } from 'common/hooks';
import { NumbersConcealer } from '../NumbersConcealer/NumbersConcealer.component';

const AvailableForWithdrawalTooltip: React.FC<React.PropsWithChildren> = () => {
  const { translate } = useI18n();

  const {
    balance: { availableWithdrawalBalanceUsd, creditBalanceUsd },
  } = useCustomer();

  if (!creditBalanceUsd || creditBalanceUsd < 0) return null;

  return (
    <div data-test='credit-funds-tooltip' className='flex-column gap-2'>
      <div className='flex-align-center flex-justify-space-between gap-16'>
        <span className='Body2_reg_12'>{translate.toText('mobile:wallets:page:credit')}</span>
        <span data-test='credit-funds-tooltip-balance' className='Body4_small_med_12'>
          <NumbersConcealer>
            $ {localizeNumber(creditBalanceUsd, { maxDigits: FIAT_MAX_FRACTION })}
          </NumbersConcealer>
        </span>
      </div>
      <div className='flex-align-center flex-justify-space-between gap-16'>
        <span className='Body2_reg_12'>{translate.toText('mobile:wallet:mobile-sheet:available-for-withdrawal')}</span>
        <span data-test='credit-funds-tooltip-available-for-withdrawal-balance' className='Body4_small_med_12'>
          <NumbersConcealer>
            ${' '}
            {localizeNumber((availableWithdrawalBalanceUsd ?? 0) < 0 ? 0 : availableWithdrawalBalanceUsd, {
              maxDigits: FIAT_MAX_FRACTION,
            })}
          </NumbersConcealer>
        </span>
      </div>
    </div>
  );
};

export default memo(AvailableForWithdrawalTooltip);
